import { useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import { TrackPlay } from 'react-huge-icons/solid'
import { useTranslation } from "react-i18next";
import { useEndActiveWorkoutMutation, useStartActiveWorkoutMutation, Workout } from "src/graphql";

interface ProfileWorkoutsSectionProps {
    workouts: Partial<Workout>[]
}
const ProfileWorkoutsSection: React.FC<ProfileWorkoutsSectionProps> = ({ workouts }) => {

    const [startingId, setStartingId] = useState<string>()
    const navigate = useNavigate();


    const [finishWorkout] = useEndActiveWorkoutMutation()

    const [startWorkout, { loading: startWorkoutLoading }] = useStartActiveWorkoutMutation({
        onCompleted() {
            navigate('/active?active=1')
        },
        onError(err) {
            if (err.message === "Active Workout already exists") {
                const res = global.confirm("האם ברצונך לסיים אימון פעיל ולהתחיל את האימון הנבחר?")

                if (res) {
                    finishWorkout({
                        onCompleted(data) {
                            startWorkout({
                                variables: {
                                    workoutId: startingId!,
                                }
                            })
                        }
                    })
                }
            }
        },
    })


    const { t, i18n: { dir } } = useTranslation();


    return (

        <section>
            <article>
                <h1>{t("profile_workouts")}</h1>
                {workouts.length === 0 ? <div>{t("no_workouts_profile")}</div> :
                    workouts.map((w) => <div key={w.id} className="flex items-center flex-col justify-center py-2">
                        <h2 className="m-0 text-xl">{w.name}</h2>
                        <div className="w-full">
                            <Button disabled={startWorkoutLoading} loading={startingId === w.id} onClick={async () => {
                                setStartingId(w.id)
                                await startWorkout({
                                    variables: {
                                        workoutId: w.id!,
                                    }
                                })
                                setStartingId(undefined)
                            }} sm>
                                <TrackPlay fontSize={20} className={`${dir() === 'rtl' && "rotate-180"}`} /> {t("start_workout")}
                            </Button>
                        </div>
                    </div>)}
            </article>
        </section >
    );
}

export default ProfileWorkoutsSection;